module.exports = __webpack_public_path__ + "media/assets/array-8fc263101cccc74ee69912edde669a09.png";